import { baseUrl } from "./Common/domain";
import axios from "axios";
import { localserver } from "../../../api/common";
export const GetCountryData = async () => {
  try {
    const res = await axios.get(`${localserver}/get_countries`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    console.log(res,"res")
    return res.data.countries;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const GetStatesData = async (countryId) => {
  console.log(countryId);
  
  try {
    const res = await axios.post(`${localserver}/get_states_by_country_id`, { country_id: countryId }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    console.log(res,"res")
    return res.data.states_list;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

